// import { Col, Container, Row } from 'react-bootstrap';
// import './Benefits.css';
// import overview from 'assets/images/features/Humaaans.png'
// import { colors } from 'styles/colors';
// const Hero = () => {
//     return (
//         <>
//             <div className='overview-section' >
//                 <section className="hero-4   pb-5 pt-2 py-sm-3">
//                     <Container>
//                         <Row className="align-items-center">
//                             <Col lg={6} md={6} className="mb-4 mb-md-0 text-center text-md-start">
//                                 <h1 className="hero-title mt-0" style={{ color: colors.primary.darkBlue }}>
//                                     Overview of <span style={{ color: colors.primary.teal }} >SalesTrackify</span> CRM.
//                                 </h1>
//                                 <p className="fs-16 text-muted pt-3 w-100 w-md-75 mx-auto mx-md-0">
//                                     SalesTrackify CRM is designed to empower sales teams with tools to streamline their workflow, improve productivity, and close deals faster. With an intuitive interface and robust features, SalesTrackify helps businesses track leads, manage sales pipelines, and analyze performance with precision.
//                                 </p>
//                             </Col>
//                             <Col lg={6} md={6} sm={12} className="text-center text-md-end ps-lg-5">
//                                 <div className="img-container text-end ps-lg-5" data-aos="zoom-in">
//                                     <Row className="align-items-center mt-md-0 mt-4">
//                                         <img src={overview} loading="lazy" className="bg-white" alt="" />

//                                     </Row>
//                                 </div>
//                             </Col>
//                         </Row>
//                     </Container>
//                 </section>
//             </div>
//         </>
//     );
// };

// export default Hero;



import { Button, Col, Container, Row } from 'react-bootstrap';
import {
    BarChart3,
    Users,
    TrendingUp,
    Mail,
    Folder,
    FileText,
    DollarSign,
    Headphones,
    Sparkles,
    ArrowRight,
    CheckCircle2,
    Zap,
    Link
} from "lucide-react";
import './Benefits.css';
import overview from 'assets/images/features/Humaaans.png'
import { colors } from 'styles/colors';
import about from 'assets/images/hero/New folder/about.png'
import { useNavigate } from "react-router-dom";
const Hero = () => {

    const navigate = useNavigate();
    const highlights = [
        "Intuitive interface designed for sales teams",
        "Track leads and manage pipelines effortlessly",
        "Analyze performance with precision",
        "Streamline workflow and boost productivity"
    ];


    const features = [
        {
            icon: BarChart3,
            emoji: "📊",
            title: "Intelligent Dashboards",
            description: "Personalized dashboards for sales, finance, and individual performance tracking. Get real-time insights with customizable widgets and KPI monitoring to make data-driven decisions quickly.",
            color: "#2dd4bf",
            gradient: "from-[#2dd4bf]/20 to-[#2dd4bf]/5"
        },
        {
            icon: Users,
            emoji: "👥",
            title: "Customer & Contact Management",
            description: "Complete 360° view of accounts and contacts with relationship tracking. Store detailed customer information, communication history, and interaction logs all in one place for better customer relationships.",
            color: "#1e3a8a",
            gradient: "from-[#1e3a8a]/20 to-[#1e3a8a]/5"
        },
        {
            icon: TrendingUp,
            emoji: "📈",
            title: "Sales Pipeline & Quotation",
            description: "Track leads, deal stages, and generate quotes with ease. Monitor deal progress through every stage, forecast revenue accurately, and close deals faster with automated workflows.",
            color: "#2dd4bf",
            gradient: "from-[#2dd4bf]/20 to-[#2dd4bf]/5"
        },
        {
            icon: Mail,
            emoji: "✉️",
            title: "Marketing Automation",
            description: "Run email/SMS campaigns and capture leads via smart forms. Nurture leads automatically with targeted campaigns, track engagement metrics, and integrate seamlessly with your sales pipeline.",
            color: "#1e3a8a",
            gradient: "from-[#1e3a8a]/20 to-[#1e3a8a]/5"
        },
        {
            icon: Folder,
            emoji: "📁",
            title: "Project & Time Management",
            description: "Assign, monitor projects and log hours for accurate billing. Track project progress, manage resources efficiently, and ensure timely delivery with milestone tracking and workload visualization.",
            color: "#2dd4bf",
            gradient: "from-[#2dd4bf]/20 to-[#2dd4bf]/5"
        },
        {
            icon: FileText,
            emoji: "📊",
            title: "Comprehensive Reports",
            description: "Access detailed analytics on leads, sales, and finances. Generate custom reports, set up automated reporting schedules, and export data in multiple formats for deeper analysis and presentations.",
            color: "#1e3a8a",
            gradient: "from-[#1e3a8a]/20 to-[#1e3a8a]/5"
        },
        {
            icon: DollarSign,
            emoji: "💰",
            title: "Finance Module",
            description: "Manage orders, invoices, expenses, and payment tracking. Automate billing cycles, track payment status, manage receivables and payables, with full audit trails for financial compliance.",
            color: "#2dd4bf",
            gradient: "from-[#2dd4bf]/20 to-[#2dd4bf]/5"
        },
        {
            icon: Headphones,
            emoji: "🎧",
            title: "Customer Support",
            description: "Resolve issues through ticketing system with SLA monitoring. Prioritize tickets by urgency, track resolution times, and maintain customer satisfaction with knowledge base integration and automated escalations.",
            color: "#1e3a8a",
            gradient: "from-[#1e3a8a]/20 to-[#1e3a8a]/5"
        }
    ];


    return (
        <>
            {/* <div className='overview-section' >
                <section className="hero-4   pb-5 pt-2 py-sm-3">
                    <Container>
                        <Row className="align-items-center">
                            <Col lg={6} md={6} className="mb-4 mb-md-0 text-center text-md-start">
                                <h1 className="hero-title mt-0" style={{ color: colors.primary.darkBlue }}>
                                    Overview of <span style={{ color: colors.primary.teal }} >SalesTrackify</span> CRM.
                                </h1>
                                <p className="fs-16 text-muted pt-3 w-100 w-md-75 mx-auto mx-md-0">
                                    SalesTrackify CRM is designed to empower sales teams with tools to streamline their workflow, improve productivity, and close deals faster. With an intuitive interface and robust features, SalesTrackify helps businesses track leads, manage sales pipelines, and analyze performance with precision.
                                </p>
                            </Col>
                            <Col lg={6} md={6} sm={12} className="text-center text-md-end ps-lg-5">
                                <div className="img-container text-end ps-lg-5" data-aos="zoom-in">
                                    <Row className="align-items-center mt-md-0 mt-4">
                                        <img src={overview} loading="lazy" className="bg-white" alt="" />

                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div> */}



            {/* <section className="relative overflow-hidden" style={{ backgroundColor: "#24347D" }}>

                <div className="absolute inset-0 bg-gradient-to-br from-[#24347D] via-[#26458D] to-[#26A2AB]"></div>


                <div className="absolute inset-0 opacity-10">
                    <svg className="h-full w-full" viewBox="0 0 1200 600" preserveAspectRatio="none">
                        <path d="M0,420 C200,360 280,520 520,460 C760,400 820,520 1200,430 L1200,600 L0,600 Z" fill="white" />
                    </svg>
                </div>


                <div className="absolute left-0 top-0 h-96 w-96 animate-pulse rounded-full bg-[#26A2AB]/20 blur-3xl"></div>
                <div className="absolute bottom-0 right-0 h-96 w-96 animate-pulse rounded-full bg-[#24347D]/40 blur-3xl"></div>

                <div className="relative mx-auto max-w-7xl px-4 py-12 sm:px-4 lg:px-6 lg:py-18">
                    <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">

                  
                        <div className="text-white">
             
                            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 backdrop-blur-sm">
                                <span className="h-2 w-2 rounded-full bg-[#26A2AB]"></span>
                                <span className="text-sm font-medium tracking-wide">AI-powered CRM for small & growing businesses</span>
                            </div>

                            <h1 className="mt-3 text-white text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl">
                                Track leads. Close deals.<br />
                                <span className="text-white/90">Automate follow-ups with AI.</span>
                            </h1>

                  
                            <p className="mt-4 max-w-xl text-lg text-white/80">
                                SalesTrackify is an all-in-one CRM to manage leads, track opportunities, automate follow-ups, and close deals faster.
                            </p>

                       
                            <div className="mt-5 flex flex-col gap-4 sm:flex-row sm:items-center">
                                <div className=" items-center overflow-hidden rounded-xl bg-white p-1 shadow-xl">
                                    <button
                                        onClick={() => navigate("/contact")}
                                        className="whitespace-nowrap rounded-lg px-9 py-3 text-sm font-semibold text-white transition-all hover:opacity-90"
                                        style={{ backgroundColor: "#26A2AB" }}
                                    >
                                        Book a Demo
                                    </button>
                                </div>
                            </div>

                   
                            <div className="mt-5 grid max-w-xl grid-cols-3 gap-4">
                                {[
                                    { value: "Leads", label: "Capture & qualify" },
                                    { value: "Deals", label: "Pipeline & quotes" },
                                    { value: "Finance", label: "Invoices & orders" }
                                ].map((stat, idx) => (
                                    <div key={idx} className="rounded-2xl bg-white/5 p-4 backdrop-blur-sm">
                                        <p className="text-xl font-bold text-white">{stat.value}</p>
                                        <p className="text-xs text-white/60">{stat.label}</p>
                                    </div>
                                ))}
                            </div>
                        </div>



                        <div className="relative">
                            <div className="rounded-3xl bg-white p-5 shadow-soft">
                                <div className="flex items-center justify-between">
                                    <p className="text-sm font-semibold text-slate-800">Sales Dashboard</p>
                                    <span className="rounded-full bg-brand-light px-3 py-1 text-xs font-semibold text-slate-600">Live</span>
                                </div>

                                <div className="mt-4 grid grid-cols-3 gap-3">
                                    <div className="rounded-2xl border border-brand-border p-3">
                                        <p className="text-xs text-slate-500">Pipeline</p>
                                        <p className="mt-1 text-lg font-bold text-slate-900">$87,230</p>
                                    </div>
                                    <div className="rounded-2xl border border-brand-border p-3">
                                        <p className="text-xs text-slate-500">New Leads</p>
                                        <p className="mt-1 text-lg font-bold text-slate-900">52</p>
                                    </div>
                                    <div className="rounded-2xl border border-brand-border p-3">
                                        <p className="text-xs text-slate-500">Conversion</p>
                                        <p className="mt-1 text-lg font-bold text-slate-900">21.5%</p>
                                    </div>
                                </div>

                                <div className="mt-5 rounded-2xl border border-brand-border p-4">
                                    <div className="flex items-center justify-between">
                                        <p className="text-sm font-semibold text-slate-800">Next Best Actions (AI)</p>
                                        <span className="text-xs font-semibold text-brand-teal">Auto</span>
                                    </div>
                                    <ul className="mt-3 space-y-2 text-sm text-slate-600">
                                        <li className="flex items-center justify-between">
                                            <span>Send follow-up email to Acme Inc.</span>
                                            <span className="text-xs font-semibold text-brand-indigo">Today</span>
                                        </li>
                                        <li className="flex items-center justify-between">
                                            <span>Assign lead “Delta Corp” to Sales Rep</span>
                                            <span className="text-xs font-semibold text-brand-indigo">Now</span>
                                        </li>
                                        <li className="flex items-center justify-between">
                                            <span>Create quote for Stark Solutions</span>
                                            <span className="text-xs font-semibold text-slate-700">This week</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="pointer-events-none absolute -right-10 -top-10 h-56 w-56 rounded-full bg-brand-teal/30 blur-3xl"></div>
                            <div className="pointer-events-none absolute -left-10 -bottom-10 h-56 w-56 rounded-full bg-white/20 blur-3xl"></div>
                        </div>
                   
                    </div>
                </div>
            </section> */}


            <section
                style={{
                    background: colors.gradient.soft,
                    padding: "80px 0",
                    textAlign: "center",
                    borderBottomLeftRadius: "30px",
                    borderBottomRightRadius: "30px",
                    marginLeft: 25,
                    marginRight: 25
                }}     >

                <h1
                    style={{
                        fontSize: "48px",
                        fontWeight: 700,
                        color: colors.primary.darkBlue,
                    }}  >
                    Features
                </h1>


                <p style={{ marginTop: "10px", fontSize: "18px", color: "#6c757d", textAlign: 'center' }} className='px-5'
                >
                    SalesTrackify is an AI-powered CRM designed to simplify sales management. From lead capture and pipeline tracking to automated follow-ups and smart invoicing, it helps businesses streamline operations and close deals faster with intelligent automation and real-time insights.
                </p>
            </section>
        </>
    );
};

export default Hero;

